var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('img',{staticClass:"logo",attrs:{"src":"https://p4-ky.wsukwai.com/udata/pkg/kwystatic/logo.png"}}),_c('p',{staticClass:"appname"},[_vm._v("快影")]),_c('p',{staticClass:"bottom"},[_c('a',{attrs:{"href":"https://beian.miit.gov.cn/#/Integrated/index"}},[_vm._v("京ICP备15023266号-5")])])])
}]

export { render, staticRenderFns }